// Unpublished Work © 2022-2023 Deere & Company.

import {combineReducers} from 'redux';
import {reducerTcombWrapper} from '@deere/cap-it-ui.redux-store-creator';
import {status as pageStatus} from './status';
import {dbsCustomer as customer} from './customer';
import {dbsLabels} from './dbs-labels';
import {DbsCustomerProfile} from '../../state/struct/dbs-customer-profile';
import {showDBSCustomerDetailsModal} from './modal-visibility';
import {dbsCustomerError} from './dbs-customer-error';

export const getDbsCustomerProfileCombinedReducer = () => {
    const combinedReducer = combineReducers({
        customer,
        dbsLabels,
        pageStatus,
        showDBSCustomerDetailsModal,
        dbsCustomerError
    });

    return reducerTcombWrapper.bind(
        this,
        {
            combinedReducer,
            stateStruct: DbsCustomerProfile
        }
    );
};
